/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  LineItemRef,
  LineItemRefOptional,
  LineItemRefMetaI,
  LineItemRefTrackedI,
} from "./line-item-ref";
import { LineItemRefTracked, LineItemRefMeta } from "./line-item-ref";
// May contain unused imports in some cases
// @ts-ignore
import type {
  WithExpiresOn,
  WithExpiresOnOptional,
  WithExpiresOnMetaI,
  WithExpiresOnTrackedI,
} from "./with-expires-on";
import { WithExpiresOnTracked, WithExpiresOnMeta } from "./with-expires-on";

/**
 *
 * @export
 * @interface LineItemWithExpiresOnRef
 */
export interface LineItemWithExpiresOnRefOptional extends LineItemRefOptional {
  /**
   * Timestamp when this line item expires and should be automatically removed
   * @type {string}
   * @memberof LineItemWithExpiresOnRef
   */
  expiresOn?: Date;
  /**
   *
   * @type {number}
   * @memberof LineItemWithExpiresOnRef
   */
  assignId?: number;
  /**
   *
   * @type {string}
   * @memberof LineItemWithExpiresOnRef
   */
  referenceId?: string;
}

export interface LineItemWithExpiresOnRef
  extends LineItemWithExpiresOnRefOptional, LineItemRef, WithExpiresOn {
  /**
   * Timestamp when this line item expires and should be automatically removed
   * @type {string}
   * @memberof LineItemWithExpiresOnRef
   */
  expiresOn?: Date;
  /**
   *
   * @type {number}
   * @memberof LineItemWithExpiresOnRef
   */
  assignId: number;
  /**
   *
   * @type {string}
   * @memberof LineItemWithExpiresOnRef
   */
  referenceId?: string;
}

export interface LineItemWithExpiresOnRefTrackedI extends LineItemRefOptional {
  /**
   * Timestamp when this line item expires and should be automatically removed
   * @type {string}
   * @memberof LineItemWithExpiresOnRef
   */
  expiresOn?: Date;
  expiresOnIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof LineItemWithExpiresOnRef
   */
  assignId?: number;
  assignIdIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof LineItemWithExpiresOnRef
   */
  referenceId?: string;
  referenceIdIsSet: boolean;
}

transformDatesMap.set(
  "LineItemWithExpiresOnRef",
  function (model: LineItemWithExpiresOnRef) {
    if (typeof model.expiresOn == "string")
      model.expiresOn = new Date(model.expiresOn);
  },
);

export type LineItemWithExpiresOnRefMetaI = MetaType<{
  //isDate: false
  //isDatetime: true
  expiresOn: PropertyMeta<MetaTypeBase<Date>>;
  //isDate: false
  //isDatetime: false
  assignId: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  referenceId: PropertyMeta<MetaTypeBase<string>>;
}>;

export var LineItemWithExpiresOnRefMeta: LineItemWithExpiresOnRefMetaI =
  {} as LineItemWithExpiresOnRefMetaI;
LineItemWithExpiresOnRefMeta = typeMeta("LineItemWithExpiresOnRef", {
  expiresOn: propertyMeta("expiresOn", false, false, false, MetaTypesBase.Date),
  assignId: propertyMeta("assignId", false, true, true, MetaTypesBase.number),
  referenceId: propertyMeta(
    "referenceId",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
});

const metaI = LineItemWithExpiresOnRefMeta;

registerMeta(() => {
  metaI.interfaces = metaI.interfaces.concat([WithExpiresOnMeta]);
  metaI.expiresOn.inheritedFrom = WithExpiresOnMeta.expiresOn;
  metaI.interfaces = metaI.interfaces.concat([LineItemRefMeta]);
  metaI.assignId.inheritedFrom = LineItemRefMeta.assignId;
  metaI.referenceId.inheritedFrom = LineItemRefMeta.referenceId;
});

export class LineItemWithExpiresOnRefTracked
  extends LineItemRefTracked
  implements LineItemWithExpiresOnRefTrackedI
{
  changeTracker: boolean = false;
  //isNew: boolean = false
  expiresOn__I?: Date = undefined;
  expiresOnIsSet: boolean = false;
  set expiresOn(v: undefined | Date) {
    if (v !== undefined) {
      this.expiresOn__I = v;
      this.expiresOnIsSet = true;
    } else {
      this.expiresOn__I = v || undefined;
      this.expiresOnIsSet = false;
    }
    this.changeTracker = true;
  }
  get expiresOn() {
    return this.expiresOn__I;
  }
  assignId__I?: number = undefined;

  get assignIdIsSet() {
    return this.assignId !== undefined;
  }
  set assignIdIsSet(v: boolean) {}
  set assignId(v: undefined | number) {
    if (v !== undefined) {
      this.assignId__I = v;
      this.assignIdIsSet = true;
    } else {
      this.assignId__I = v || undefined;
      this.assignIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get assignId() {
    return this.assignId__I;
  }
  referenceId__I?: string = undefined;
  referenceIdIsSet: boolean = false;
  set referenceId(v: undefined | string) {
    if (v !== undefined) {
      this.referenceId__I = v;
      this.referenceIdIsSet = true;
    } else {
      this.referenceId__I = v || undefined;
      this.referenceIdIsSet = false;
    }
    this.changeTracker = true;
  }
  get referenceId() {
    return this.referenceId__I;
  }
  constructor(
    config?: LineItemWithExpiresOnRefOptional,
    options?: AssignOptions,
  ) {
    super(config, options);
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    if (this.assignIdIsSet == true && other?.assignIdIsSet == true)
      return this.assignId == other.assignId;
    if (this.referenceIdIsSet == true && other?.referenceIdIsSet == true)
      return this.referenceId == other.referenceId;

    return this == other;
  }
  setIds() {
    if (this.anySet() && !!this.assignId) {
      this.assignIdIsSet = true;
    }
  }
  assignFrom(
    config: LineItemWithExpiresOnRefOptional,
    options?: AssignOptions,
  ): LineItemWithExpiresOnRefTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.expiresOn && this.expiresOnApplyFilter(optionsRequired.filter)) {
      this.expiresOn = config.expiresOn;
      if (optionsRequired.unassign) this.expiresOnIsSet = false;
      else this.expiresOnIsSet = true;
    }
    if (config.assignId && this.assignIdApplyFilter(optionsRequired.filter)) {
      this.assignId = config.assignId;
      if (optionsRequired.unassign) this.assignIdIsSet = false;
      else this.assignIdIsSet = true;
    }
    if (
      config.referenceId &&
      this.referenceIdApplyFilter(optionsRequired.filter)
    ) {
      this.referenceId = config.referenceId;
      if (optionsRequired.unassign) this.referenceIdIsSet = false;
      else this.referenceIdIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): LineItemWithExpiresOnRefTrackedI {
    const cloned = {} as LineItemWithExpiresOnRefTrackedI;
    if (
      this.expiresOnIsSetDeep() &&
      this.expiresOnApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.expiresOnIsSet = true;
      cloned.expiresOn = this.expiresOn;
    } else {
      //cloned.expiresOnIsSet = false
    }
    if (
      this.assignIdIsSetDeep() &&
      this.assignIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.assignIdIsSet = true;
      cloned.assignId = this.assignId;
    } else {
      //cloned.assignIdIsSet = false
    }
    if (
      this.referenceIdIsSetDeep() &&
      this.referenceIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.referenceIdIsSet = true;
      cloned.referenceId = this.referenceId;
    } else {
      //cloned.referenceIdIsSet = false
    }
    if (!isDeleted(this) && !this.assignIdIsSet) updateIsNew(cloned, true);
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): LineItemWithExpiresOnRefTrackedI {
    if (!this.expiresOnApplyFilter(filter)) this.expiresOnIsSet = false;

    if (!this.assignIdApplyFilter(filter)) this.assignIdIsSet = false;

    if (!this.referenceIdApplyFilter(filter)) this.referenceIdIsSet = false;

    return this;
  }
  expiresOnApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      LineItemWithExpiresOnRefMeta.expiresOn,
      LineItemWithExpiresOnRefMeta,
      this.expiresOn,
      this,
    );
  }
  expiresOnIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.expiresOnIsSet && this.expiresOnApplyFilter(filter)) return true;

    return false;
  }
  assignIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      LineItemWithExpiresOnRefMeta.assignId,
      LineItemWithExpiresOnRefMeta,
      this.assignId,
      this,
    );
  }
  assignIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.assignIdIsSet && this.assignIdApplyFilter(filter)) return true;

    return false;
  }
  referenceIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      LineItemWithExpiresOnRefMeta.referenceId,
      LineItemWithExpiresOnRefMeta,
      this.referenceId,
      this,
    );
  }
  referenceIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.referenceIdIsSet && this.referenceIdApplyFilter(filter))
      return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.expiresOnIsSetDeep(filter)) return true;
    if (this.assignIdIsSetDeep(filter)) return true;
    if (this.referenceIdIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
